import {
    Component,
    ViewChild,
    Injector,
    Input,
    OnInit,
    InjectionToken,
    Inject,
    EventEmitter,
    Output
} from '@angular/core';
import {
    Overlay,
    OverlayOrigin,
    ScrollStrategyOptions
} from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { INFO_TEXT_DATA} from '../info-text-data';



@Component({
    selector: 'app-info-text',
    templateUrl: './info-text.component.html',
    styleUrls: ['./info-text.component.css']
})
export class InfoTextComponent implements OnInit {
    @ViewChild(OverlayOrigin)
    _overlayOrigin: OverlayOrigin;
    @Input()
    infoData: string;
    @Input()
    pulseAnimation: boolean = true;
    @Input()
    panelClasses: Array<string> = [];
    @Output()
    detachEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private overlay: Overlay,
        private _injector: Injector,
        private sso: ScrollStrategyOptions
    ) {}

    private createInjector(dataToPass): PortalInjector {
        const injectorTokens = new WeakMap();
        injectorTokens.set(INFO_TEXT_DATA, dataToPass);
        return new PortalInjector(this._injector, injectorTokens);
    }

    ngOnInit() {
        setTimeout(() => {
            const overlayRef = this.overlay.create({
                positionStrategy: this.overlay
                    .position()
                    .connectedTo(
                        this._overlayOrigin.elementRef,
                        { originX: 'start', originY: 'bottom' },
                        { overlayX: 'start', overlayY: 'top' }
                    ),
                scrollStrategy: this.sso.reposition(),
                hasBackdrop: true,
                backdropClass: 'lel',
                panelClass: this.panelClasses
            });

            const infoPortal = new ComponentPortal(
                InfoTextTemplateComponent,
                null,
                this.createInjector({
                    infoData: this.infoData,
                    pulseAnimation: this.pulseAnimation
                })
            );
            overlayRef.attach(infoPortal);
            overlayRef.backdropClick().subscribe(
                () => {
                overlayRef.detach()
                this.detachEvent.emit();
            });
        })
    }
}

@Component({
    template: `<div class="info-text" [class.pulse-animation]="data.pulseAnimation" [innerHtml]="data.infoData"></div>`,
    styles: [
        `.info-text {
    background-color: white;
    padding: 10px;
    border: 1px solid #bfbfbf;
    box-shadow: 2px 4px 5px rgba(0,0,0,0.15);
    border-radius: 5px;
    color: #143b50;
    font-size: 15px;
    }

   .pulse-animation  {
      animation: pulse 2s infinite;
   }

   .pulse-animation:hover  {
      animation: none;
   }

    @-webkit-keyframes pulse {
      0% {
        -webkit-box-shadow: 0 0 0 0 rgba(15, 60, 84,0.4);
      }
      70% {
          -webkit-box-shadow: 0 0 0 6px rgba(15, 60, 84,0);
      }
      100% {
          -webkit-box-shadow: 0 0 0 0 rgba(15, 60, 84,0);
      }
    }
    @keyframes pulse {
      0% {
        -moz-box-shadow: 0 0 0 0 rgba(15, 60, 84,0.4);
        box-shadow: 0 0 0 0 rgba(15, 60, 84,0.4);
      }
      70% {
          -moz-box-shadow: 0 0 0 6px rgba(15, 60, 84,0);
          box-shadow: 0 0 0 6px rgba(15, 60, 84,0);
      }
      100% {
          -moz-box-shadow: 0 0 0 0 rgba(0,0,0,0);
          box-shadow: 0 0 0 0 rgba(0,0,0,0);
      }
    `
    ]
})
export class InfoTextTemplateComponent {
    constructor(@Inject(INFO_TEXT_DATA) public data: any) {}
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/info-text/info-text.component.ts